import { useState, type FormEvent } from 'react';

const inputClass =
  'w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500';

export default function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showNotFound, setShowNotFound] = useState(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowNotFound(true);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full" noValidate>
      <div>
        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
          User Name
        </label>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
            setShowNotFound(false);
          }}
          className={inputClass}
          placeholder="Enter your user name"
        />
      </div>

      <div className="mt-5">
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
          Password
        </label>
        <div className="relative">
          <input
            id="password"
            name="password"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setShowNotFound(false);
            }}
            className={`${inputClass} pr-12`}
            placeholder="Enter your password"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
          >
            <i className={`${showPassword ? 'ri-eye-off-line' : 'ri-eye-line'} text-lg`}></i>
          </button>
        </div>
      </div>

      {showNotFound && (
        <div className="mt-6 flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3.5">
          <div className="w-6 h-6 flex items-center justify-center shrink-0">
            <i className="ri-error-warning-line text-amber-500 text-lg"></i>
          </div>
          <div>
            <p className="text-sm font-semibold text-amber-800">Your details were not found.</p>
            <p className="text-sm text-amber-700 mt-0.5">Please try again.</p>
          </div>
        </div>
      )}

      <button
        type="submit"
        className="mt-7 w-full px-10 py-3.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
      >
        <i className="ri-login-box-line text-base"></i>
        Sign In
      </button>
    </form>
  );
}